import { useState, useEffect } from 'react';
import { UtensilsCrossed, Cookie, IceCream, Plus, Coffee, Star, Loader2 } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const categories = [
  { id: 'brunch', name: 'Malaysian Brunch', icon: UtensilsCrossed },
  { id: 'flanquette', name: 'Signature Flaguette', icon: UtensilsCrossed },
  { id: 'pastries', name: 'Fresh Pastries', icon: Cookie },
  { id: 'gelato', name: 'Artisan Gelato', icon: IceCream },
  { id: 'extras', name: 'Extras', icon: Plus },
];

// Featured items with images
const featuredWithImages = [
  { 
    name: 'Nasi Lemak', 
    image: 'https://customer-assets.emergentagent.com/job_3d290920-bb19-4016-858f-1f272e69a4f5/artifacts/0cphl1so_nasi%20lemak.png',
    price: '£11.95',
    badge: 'SIGNATURE'
  },
  { 
    name: 'Laksa', 
    image: 'https://customer-assets.emergentagent.com/job_3d290920-bb19-4016-858f-1f272e69a4f5/artifacts/4c7c8ply_Laksa.png',
    price: '£15.50',
    badge: 'AUTHENTIC'
  },
  { 
    name: 'Murtabak', 
    image: 'https://customer-assets.emergentagent.com/job_3d290920-bb19-4016-858f-1f272e69a4f5/artifacts/se2yyd3q_Murtabak%20image.jpg',
    price: '£8.50',
    badge: 'MALAYSIAN'
  },
];

const menuItems = {
  brunch: [
    { 
      name: 'Nasi Lemak', 
      badge: 'FAMILY RECIPE · GF',
      description: 'The quintessential Malay Breakfast consisting of traditional coconut rice with our secret Sambal sauce (Reg or Spicy), served with fried crispy anchovies, roasted peanuts, fresh cucumber with 2 poached eggs/2 fried eggs or French omelette.', 
      price: '11.95',
      addon: 'With Special Side (breaded chicken, Sambal Beef Sausage or Meatballs)',
      addonPrice: '14.95',
      highlight: true,
      image: 'https://customer-assets.emergentagent.com/job_3d290920-bb19-4016-858f-1f272e69a4f5/artifacts/0cphl1so_nasi%20lemak.png'
    },
    { 
      name: 'Laksa', 
      badge: 'FAMILY RECIPE',
      description: 'A traditional bowl of comfort broth that blends creamy coconut milk with spicy curry served with noodles, herbs, freshly sliced cucumber, beansprouts, with fishballs, fishcake, fried tofu, garnished with sweet pepper and coriander. MSG free!', 
      price: '15.50',
      variants: [
        { name: 'With Prawns / Chicken', price: '18.95' },
        { name: 'Vegan (rice noodles) GF/Ve', price: '15.50' }
      ],
      highlight: true,
      image: 'https://customer-assets.emergentagent.com/job_3d290920-bb19-4016-858f-1f272e69a4f5/artifacts/4c7c8ply_Laksa.png'
    },
    { 
      name: 'Murtabak', 
      badge: 'FAMILY RECIPE · MALAYSIAN',
      description: 'Malaysian stuffed pan fried folded bread, a traditional delicacy filled with minced meat, onions, and eggs, served with curry dipping sauce.', 
      price: '8.50',
      highlight: true,
      image: 'https://customer-assets.emergentagent.com/job_3d290920-bb19-4016-858f-1f272e69a4f5/artifacts/se2yyd3q_Murtabak%20image.jpg'
    },
    { 
      name: 'Sambal Cilbir', 
      badge: 'FUSION',
      description: 'Poached eggs on a bed of garlic herbed yogurt, with our secret sambal oil, served with sourdough toasts.', 
      price: '11.95',
      addon: 'With Special Side',
      addonPrice: '14.95'
    },
    { 
      name: 'Hello, Avocado', 
      badge: 'Ve',
      description: 'Smashed avocados lightly seasoned with paprika, mixed ground pepper and salt, on 2 sourdough toasts.', 
      price: '8.50',
      addon: 'With Poached Eggs',
      addonPrice: '11.75'
    },
    { 
      name: 'Buttered Up', 
      description: 'Sourdough Toast with butter & Jam/honey or sambal.', 
      price: '5.00'
    },
    { 
      name: 'Murtabak - Chicken Mince', 
      badge: 'MALAYSIAN',
      description: 'Malaysian stuffed pan fried folded bread delicacy served with fresh salad and sauce.', 
      price: '8.50',
      addon: 'French Toasted (Optional)',
      addonPrice: '+2.00'
    },
    { 
      name: 'Murtabak - Potato', 
      badge: 'V/Ve · MALAYSIAN',
      description: 'Malaysian stuffed pan fried folded bread delicacy served with fresh salad and sauce.', 
      price: '8.00',
      addon: 'French Toasted (Optional)',
      addonPrice: '+2.00'
    },
  ],
  flanquette: [
    { 
      name: 'BBQ Breaded Chicken', 
      description: 'Baked breaded chicken, layered with green baby-leaf salad, BBQ sauce, mozzarella cheese and rich mayonnaise sauce.', 
      price: '7.70'
    },
    { 
      name: 'Black Cajun Chicken', 
      description: 'House cooked blackened cajun spiced chicken layered with baby leaf greens, guacamole, sliced olives, sliced cheddar cheese, dressed in ranch sauce.', 
      price: '7.70'
    },
    { 
      name: 'Halloumi Arrabbiata', 
      badge: 'V',
      description: 'Baby leaf salad, vegan pesto, halloumi cheese, sliced olives, cherry tomatoes and a rich arrabbiata sauce.', 
      price: '7.70'
    },
    { 
      name: 'Falafel', 
      badge: 'Ve',
      description: 'Baked chickpea falafel bites, layered with hummus, baby leaf salad, sliced onions, red cabbage flavored with pickled cucumber, rich tahini sauce garnished with parsley.', 
      price: '7.70'
    },
    { 
      name: 'Sambal Tuna Melt', 
      description: 'Sambal stir fried tuna, layered on a bed of rich mayo with sliced onions, cheddar cheese and fresh baby leaf greens.', 
      price: '7.70'
    },
  ],
  pastries: [
    { name: 'Croissant', description: 'Classic buttery croissant, baked fresh daily', price: '2.50' },
    { name: 'Almond Croissant', description: 'Filled with almond cream', price: '3.85' },
    { name: 'Raspberry Lattice', description: 'Fresh raspberry pastry', price: '3.95' },
    { name: 'Specials Croissant', description: 'Ask about today\'s special filling', price: '4.50' },
    { name: 'Pain Au Chocolat', description: 'Chocolate-filled pastry', price: '2.75' },
    { name: 'Pain Au Raisin', description: 'Sweet raisin swirl', price: '2.75' },
    { name: 'Pain Chocolate Suisse Pepite', description: 'Swiss chocolate chip pastry', price: '3.70' },
    { name: 'Cinnamon Roll', description: 'Glazed cinnamon swirl', price: '3.65' },
    { name: 'Pistachio Swirl', description: 'Pistachio cream pastry', price: '3.90' },
    { name: 'Apricot Croissant', description: 'Fresh apricot filled', price: '3.65' },
    { name: 'Apple Turnover', description: 'Warm apple filling', price: '3.50' },
  ],
  gelato: [
    { 
      name: 'Artisan Sicilian Gelato', 
      description: 'Choose from Chocolate, Salted Caramel, Vanilla, Pistachio, or Mint Chocolate Chip',
      variants: [
        { name: 'Single Scoop', price: '4.75' },
        { name: 'Double Scoop', price: '7.00' },
        { name: 'Triple Scoop', price: '9.00' },
        { name: 'Quad Scoop', price: '10.75' },
      ]
    },
    { name: 'Gelato Shake', badge: 'NEW', description: 'Blended gelato shake', price: '6.95' },
    { name: 'Topping', description: 'Add a topping to your gelato', price: '1.00' },
    { name: 'Sauce', description: 'Add sauce to your gelato', price: '0.50' },
  ],
  extras: [
    { name: 'Poached Egg', price: '1.50' },
    { name: 'Fried Egg', price: '1.50' },
    { name: 'Omelette', price: '4.50' },
    { name: 'Special Side', description: 'Breaded chicken, Sambal Beef Sausage or Meatballs', price: '3.00' },
    { name: 'Sambal / Jam / Honey', price: '1.50' },
    { name: 'Toast', price: '2.50' },
  ]
};

export default function MenuPage() {
  const [activeCategory, setActiveCategory] = useState('brunch');
  const [drinksData, setDrinksData] = useState({});
  const [drinksCategories, setDrinksCategories] = useState([]);
  const [loadingDrinks, setLoadingDrinks] = useState(true);
  const [activeDrinkCategory, setActiveDrinkCategory] = useState('hot-drinks');

  useEffect(() => {
    const fetchDrinks = async () => {
      try {
        const [categoriesRes, itemsRes] = await Promise.all([
          axios.get(`${API}/menu-categories`),
          axios.get(`${API}/menu-items`)
        ]);
        
        // Filter for drink categories only
        const drinkCats = categoriesRes.data.filter(cat => 
          ['hot-drinks', 'teas', 'cold-drinks', 'speciality-drinks'].includes(cat.slug)
        ).sort((a, b) => a.sort_order - b.sort_order);
        
        setDrinksCategories(drinkCats);
        
        // Group drink items by category
        const drinkItems = itemsRes.data.filter(item => 
          ['hot-drinks', 'teas', 'cold-drinks', 'speciality-drinks'].includes(item.category)
        );
        
        const grouped = {};
        drinkItems.forEach(item => {
          if (!grouped[item.category]) {
            grouped[item.category] = [];
          }
          grouped[item.category].push(item);
        });
        
        // Sort items within each category
        Object.keys(grouped).forEach(cat => {
          grouped[cat].sort((a, b) => a.sort_order - b.sort_order);
        });
        
        setDrinksData(grouped);
        if (drinkCats.length > 0) {
          setActiveDrinkCategory(drinkCats[0].slug);
        }
      } catch (error) {
        console.error('Error fetching drinks:', error);
      } finally {
        setLoadingDrinks(false);
      }
    };
    
    fetchDrinks();
  }, []);

  return (
    <div className="min-h-screen pt-24" data-testid="menu-page">
      {/* Hero Section */}
      <section className="py-16 md:py-24" style={{ backgroundColor: '#F5F0E6' }}>
        <div className="container mx-auto px-4 md:px-8 max-w-7xl">
          <div
            
            
            
            className="text-center max-w-3xl mx-auto"
          >
            <p className="text-xs tracking-[0.2em] text-neutral-500 uppercase mb-4">Our Menu</p>
            <h1 className="font-serif text-5xl md:text-6xl font-bold text-black mb-6">
              Crafted with <span className="italic">Love</span>
            </h1>
            <p className="text-neutral-600 text-lg mb-4">
              <strong>Organic Houseblend Coffee</strong> · <strong>Malaysian Fusion Brunch</strong> · <strong>Freshly Baked Pastries</strong>
            </p>
            <p className="text-neutral-500">
              Our Malaysian dishes feature our secret family recipes. Pastries are baked fresh daily.
            </p>
            <p className="text-neutral-400 text-sm italic">(passed down to my mum from our Nannyma)</p>
          </div>
        </div>
      </section>

      {/* Featured Items with Images */}
      <section className="py-12 bg-white border-b border-neutral-200">
        <div className="container mx-auto px-4 md:px-8 max-w-7xl">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {featuredWithImages.map((item, index) => {
              // Custom crop positions for each image
              const cropPositions = {
                'Nasi Lemak': 'center 40%',
                'Laksa': 'center 35%',
                'Murtabak': 'center 15%'
              };
              
              return (
                <div
                  key={item.name}
                  
                  
                  
                  className="relative group overflow-hidden"
                >
                  <div className="aspect-[4/3] overflow-hidden">
                    <img 
                      src={item.image} 
                      alt={item.name}
                      className="w-full h-[140%] object-cover group-hover:scale-105 transition-transform duration-500"
                      style={{ objectPosition: cropPositions[item.name] || 'center 30%' }}
                    />
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
                  <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                    <span className="text-[10px] tracking-wider uppercase bg-white/20 backdrop-blur-sm px-2 py-1 mb-2 inline-block">
                      {item.badge}
                    </span>
                    <h3 className="font-serif text-2xl font-semibold">{item.name}</h3>
                    <p className="text-white/80">{item.price}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Organic Coffee Highlight */}
      <section className="py-12 bg-black text-white">
        <div className="container mx-auto px-4 md:px-8 max-w-4xl">
          <div className="flex flex-col md:flex-row items-center justify-center gap-8 text-center md:text-left">
            <Coffee size={48} className="flex-shrink-0" strokeWidth={1} />
            <div>
              <h3 className="font-serif text-2xl font-semibold mb-2">100% Organic Houseblend</h3>
              <p className="text-neutral-400">
                Our signature organic houseblend coffee is carefully sourced from sustainable farms 
                and roasted to perfection. Ask about our specialty drinks - pistachio lattes and chai lattes are customer favorites!
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Menu Content */}
      <section className="py-16 md:py-24 bg-white">
        <div className="container mx-auto px-4 md:px-8 max-w-6xl">
          {/* Category Tabs */}
          <div className="flex justify-center mb-16 overflow-x-auto" data-testid="menu-categories">
            <div className="inline-flex border border-neutral-200 flex-wrap justify-center">
              {categories.map((category) => (
                <button
                  key={category.id}
                  onClick={() => setActiveCategory(category.id)}
                  data-testid={`menu-tab-${category.id}`}
                  className={`flex items-center px-4 md:px-6 py-4 text-xs tracking-wider uppercase font-medium transition-all whitespace-nowrap ${
                    activeCategory === category.id
                      ? 'bg-black text-white'
                      : 'bg-white text-black hover:bg-neutral-50'
                  }`}
                >
                  <category.icon size={16} className="mr-2" />
                  {category.name}
                </button>
              ))}
            </div>
          </div>

          {/* Menu Items */}
          <div
            key={activeCategory}
            
            
            
            className="space-y-6"
            data-testid="menu-items-container"
          >
            {/* Section intro for special categories */}
            {activeCategory === 'brunch' && (
              <div className="text-center mb-8 p-6" style={{ backgroundColor: '#F5F0E6' }}>
                <p className="text-neutral-600 mb-2">
                  <strong>Malaysian dishes marked with "FAMILY RECIPE"</strong> are made with secret family recipes 
                  passed down through generations.
                </p>
                <div className="flex justify-center items-center gap-1 mt-4">
                  {[1,2,3,4,5].map(i => (
                    <Star key={i} size={16} className="text-yellow-500 fill-yellow-500" />
                  ))}
                  <span className="ml-2 text-sm text-neutral-500">"Best Nasi Lemak in East London" - Google Reviews</span>
                </div>
              </div>
            )}
            {activeCategory === 'flanquette' && (
              <p className="text-center text-neutral-500 text-sm mb-8 italic">
                Our signature sourdough baguette wraps · Subject to availability
              </p>
            )}
            {activeCategory === 'pastries' && (
              <div className="text-center mb-8 p-6" style={{ backgroundColor: '#F5F0E6' }}>
                <p className="text-neutral-600">
                  <strong>Baked fresh daily</strong> · See what's available at the counter each morning
                </p>
              </div>
            )}

            {menuItems[activeCategory].map((item, index) => (
              <div
                key={item.name}
                
                
                
                className={`py-6 border-b border-neutral-100 group ${item.highlight ? 'p-6 -mx-4 md:-mx-6' : ''}`}
                style={item.highlight ? { backgroundColor: '#F5F0E6' } : {}}
                data-testid={`menu-item-${index}`}
              >
                <div className="flex gap-6">
                  {/* Image if available */}
                  {item.image && (
                    <div className="flex-shrink-0 w-24 h-24 md:w-32 md:h-32 overflow-hidden">
                      <img 
                        src={item.image} 
                        alt={item.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                  )}
                  
                  <div className="flex-1">
                    <div className="flex justify-between items-start mb-2">
                      <div className="flex items-center flex-wrap gap-2">
                        <h3 className="font-serif text-xl md:text-2xl font-medium text-black">{item.name}</h3>
                        {item.badge && (
                          <span className={`text-[10px] tracking-wider uppercase px-2 py-1 ${
                            item.badge.includes('FAMILY') 
                              ? 'bg-black text-white' 
                              : 'bg-neutral-200 text-neutral-700'
                          }`}>
                            {item.badge}
                          </span>
                        )}
                      </div>
                      {item.price && (
                        <span className="font-serif text-xl font-medium text-black ml-4 whitespace-nowrap">£{item.price}</span>
                      )}
                    </div>
                    
                    {item.description && (
                      <p className="text-neutral-500 text-sm leading-relaxed max-w-3xl">{item.description}</p>
                    )}
                    
                    {/* Variants */}
                    {item.variants && (
                      <div className="mt-4 space-y-2 pl-4 border-l-2 border-neutral-200">
                        {item.variants.map((variant, vIndex) => (
                          <div key={vIndex} className="flex justify-between items-center">
                            <span className="text-neutral-600 text-sm">{variant.name}</span>
                            <span className="font-medium text-black">£{variant.price}</span>
                          </div>
                        ))}
                      </div>
                    )}
                    
                    {/* Add-on option */}
                    {item.addon && (
                      <div className="mt-3 flex justify-between items-center text-sm">
                        <span className="text-neutral-500 italic">+ {item.addon}</span>
                        <span className="font-medium text-black">{item.addonPrice.includes('+') ? item.addonPrice : `£${item.addonPrice}`}</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Dietary Note */}
          <div className="mt-16 text-center space-y-2">
            <p className="text-neutral-500 text-sm">
              <span className="font-medium">GF</span> = Gluten Free · <span className="font-medium">V</span> = Vegetarian · <span className="font-medium">Ve</span> = Vegan
            </p>
            <p className="text-neutral-500 text-sm">
              Please inform our staff of any allergies or dietary requirements. We store gluten-free and vegan options separately.
            </p>
          </div>
        </div>
      </section>

      {/* Signature Dish Section */}
      <section className="py-24 bg-black text-white">
        <div className="container mx-auto px-4 md:px-8 max-w-4xl text-center">
          <div
            
             
            
          >
            <span className="inline-block text-[10px] tracking-wider uppercase bg-white text-black px-3 py-1 mb-6">
              FAMILY SECRET RECIPE
              <span className="block text-xs font-normal text-neutral-500 mt-1 italic">(passed down to my mum from our Nannyma)</span>
            </span>
            <h2 className="font-serif text-4xl md:text-5xl font-semibold mb-6">
              Nasi Lemak
            </h2>
            <p className="text-neutral-400 leading-relaxed mb-6 max-w-2xl mx-auto">
              The heart of our menu. A traditional Malaysian breakfast made with our secret family 
              Sambal sauce recipe, passed down through generations. Coconut rice, crispy anchovies, 
              roasted peanuts, fresh cucumber, and perfectly cooked eggs.
            </p>
            <div className="flex justify-center items-center gap-1 mb-4">
              {[1,2,3,4,5].map(i => (
                <Star key={i} size={20} className="text-yellow-400 fill-yellow-400" />
              ))}
            </div>
            <p className="text-neutral-500 text-sm italic mb-6">"The best Nasi Lemak in the whole of East London" - Google Review</p>
            <p className="font-serif text-3xl">From £11.95</p>
          </div>
        </div>
      </section>

      {/* Drinks Section */}
      <section className="py-16 md:py-24 bg-white" id="drinks">
        <div className="container mx-auto px-4 md:px-8 max-w-6xl">
          {/* Section Header */}
          <div className="text-center mb-12">
            <p className="text-xs tracking-[0.2em] text-neutral-500 uppercase mb-4">Beverages</p>
            <h2 className="font-serif text-4xl md:text-5xl font-bold text-black mb-4">
              Our <span className="italic">Drinks</span>
            </h2>
            <p className="text-neutral-500 max-w-2xl mx-auto">
              From our signature organic houseblend coffee to specialty lattes and refreshing iced drinks
            </p>
          </div>

          {/* Extras Info Banner */}
          <div className="mb-12 p-6 bg-neutral-100 text-center">
            <p className="text-sm text-neutral-600 mb-2">
              <strong>Extras:</strong> Decaf +60p · Ice +60p · Oat/Almond/Coconut Milk +50p
            </p>
            <p className="text-sm text-neutral-500">
              Syrups +40p: Vanilla, Caramel, Hazelnut, Gingerbread, Pumpkin Spice, Pistachio, Strawberry, Rose
            </p>
          </div>

          {loadingDrinks ? (
            <div className="flex justify-center py-12">
              <Loader2 className="animate-spin text-neutral-400" size={32} />
            </div>
          ) : drinksCategories.length > 0 ? (
            <>
              {/* Drink Category Tabs */}
              <div className="flex justify-center mb-12 overflow-x-auto" data-testid="drinks-categories">
                <div className="inline-flex border border-neutral-200 flex-wrap justify-center">
                  {drinksCategories.map((category) => (
                    <button
                      key={category.slug}
                      onClick={() => setActiveDrinkCategory(category.slug)}
                      data-testid={`drinks-tab-${category.slug}`}
                      className={`flex items-center px-4 md:px-6 py-4 text-xs tracking-wider uppercase font-medium transition-all whitespace-nowrap ${
                        activeDrinkCategory === category.slug
                          ? 'bg-black text-white'
                          : 'bg-white text-black hover:bg-neutral-50'
                      }`}
                    >
                      <Coffee size={16} className="mr-2" />
                      {category.name}
                    </button>
                  ))}
                </div>
              </div>

              {/* Drink Items Grid */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-testid="drinks-items-container">
                {(drinksData[activeDrinkCategory] || []).map((item, index) => (
                  <div
                    key={item.id}
                    className="flex justify-between items-start py-4 px-6 border border-neutral-100 hover:bg-neutral-50 transition-colors"
                    data-testid={`drink-item-${index}`}
                  >
                    <div className="flex-1">
                      <h3 className="font-serif text-lg font-medium text-black">{item.name}</h3>
                      {item.description && (
                        <p className="text-neutral-500 text-sm mt-1">{item.description}</p>
                      )}
                    </div>
                    <span className="font-medium text-black ml-4 whitespace-nowrap">£{item.price}</span>
                  </div>
                ))}
              </div>
            </>
          ) : (
            <p className="text-center text-neutral-500">Drinks menu coming soon...</p>
          )}
        </div>
      </section>

      {/* Salad Note */}
      <section className="py-16" style={{ backgroundColor: '#F5F0E6' }}>
        <div className="container mx-auto px-4 md:px-8 max-w-4xl text-center">
          <h3 className="font-serif text-2xl font-semibold text-black mb-4">Salads</h3>
          <p className="text-neutral-600">
            Just ask us, we might be able to toss something up for you!
          </p>
        </div>
      </section>
    </div>
  );
}
